/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalDocument,
    ExternalDocumentFromJSON,
    ExternalDocumentFromJSONTyped,
    ExternalDocumentToJSON,
    ExternalPartners,
    ExternalPartnersFromJSON,
    ExternalPartnersFromJSONTyped,
    ExternalPartnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalDocumentExternalPartnerResponse
 */
export interface ExternalDocumentExternalPartnerResponse {
    /**
     * 
     * @type {ExternalPartners}
     * @memberof ExternalDocumentExternalPartnerResponse
     */
    partner?: ExternalPartners;
    /**
     * 
     * @type {number}
     * @memberof ExternalDocumentExternalPartnerResponse
     */
    responseCode?: number;
    /**
     * 
     * @type {ExternalDocument}
     * @memberof ExternalDocumentExternalPartnerResponse
     */
    data?: ExternalDocument;
}

export function ExternalDocumentExternalPartnerResponseFromJSON(json: any): ExternalDocumentExternalPartnerResponse {
    return ExternalDocumentExternalPartnerResponseFromJSONTyped(json, false);
}

export function ExternalDocumentExternalPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalDocumentExternalPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partner': !exists(json, 'partner') ? undefined : ExternalPartnersFromJSON(json['partner']),
        'responseCode': !exists(json, 'responseCode') ? undefined : json['responseCode'],
        'data': !exists(json, 'data') ? undefined : ExternalDocumentFromJSON(json['data']),
    };
}

export function ExternalDocumentExternalPartnerResponseToJSON(value?: ExternalDocumentExternalPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partner': ExternalPartnersToJSON(value.partner),
        'responseCode': value.responseCode,
        'data': ExternalDocumentToJSON(value.data),
    };
}


